<template>
    <el-card class="box-card">
        <div slot="header" class="clear-fix">
            <span>奥迪诶六</span>
            <el-button style="float: right; padding: 3px 0" type="text">置顶</el-button>
        </div>
        <div>
            <div>筛选字段</div>
            <div>ISE细分市场 能源形式 变速箱形式</div>
        </div>
    </el-card>
</template>

<script>
export default {
    name: 'researchplan'
}
</script>
